module.exports = __webpack_public_path__ + "static/headshot-400x400-4fa8c6ba018e28a43bbb97fe163d3f93.jpg";